import { UiScrollPanelComponent } from '@common/ui/frontend-shared/scrollpanel';
import { LayoutSidebarService } from './sidebar.service';
import { UiFeatureHighlightComponent } from '@common/ui/frontend-shared/feature-highlight';
import { NgClass, AsyncPipe } from '@angular/common';
import { UiIconComponent } from '@common/ui/frontend-shared/icons';
import { LayoutSidebarMenuComponent } from './sidebar-menu.component';
import * as i0 from "@angular/core";
import * as i1 from "./sidebar.service";
const _c0 = ["layoutMenuScroller"];
const _c1 = () => ({
  height: "100%"
});
const _c2 = a0 => ({
  "pin-menu": a0
});
function LayoutSidebarComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("click", function LayoutSidebarComponent_Conditional_3_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.sidebarService.onClickPinMenu($event));
    });
    i0.ɵɵelement(3, "ui-icon", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 2, ctx_r1.sidebarService.anchored$) ? "Men\u00FC einklappen" : "Men\u00FC offen halten")("ngClass", i0.ɵɵpureFunction1(6, _c2, i0.ɵɵpipeBind1(2, 4, ctx_r1.sidebarService.anchored$)));
  }
}
export let LayoutSidebarComponent = /*#__PURE__*/(() => {
  class LayoutSidebarComponent {
    constructor(sidebarService) {
      this.sidebarService = sidebarService;
      this.showPinToggle = true;
      this.expandAll = false;
      sidebarService.enableSidebar(true);
      sidebarService.onMoveMenuScrollerBar$.subscribe(() => {
        this.layoutMenuScrollerViewChild?.moveBar();
      });
    }
    ngAfterViewInit() {
      setTimeout(() => {
        this.layoutMenuScrollerViewChild.moveBar();
      }, 100);
    }
    ngOnDestroy() {
      this.sidebarService.enableSidebar(false);
    }
    static {
      this.ɵfac = function LayoutSidebarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutSidebarComponent)(i0.ɵɵdirectiveInject(i1.LayoutSidebarService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: LayoutSidebarComponent,
        selectors: [["layout-sidebar"]],
        viewQuery: function LayoutSidebarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.layoutMenuScrollerViewChild = _t.first);
          }
        },
        inputs: {
          reset: "reset",
          showPinToggle: "showPinToggle",
          expandAll: "expandAll",
          model: [0, "menuModel", "model"]
        },
        decls: 9,
        vars: 7,
        consts: [["layoutMenuScroller", ""], [1, "layout-sidebar", 3, "mouseenter", "mouseleave"], [1, "layout-sidebar-anchor-wrapper"], ["highlightId", "sidebar-anchor", "infoText", "Zu wenig Platz? Das Men\u00FC kann jetzt eingeklappt werden!", "creationDate", "2021-07-01", "borderRadius", "20px", "position", "right"], ["href", "#", 1, "layout-sidebar-anchor", 3, "title", "ngClass"], [1, "sidebar-scroll-content"], [1, "layout-menu-container"], ["layout-sidebar-menu", "", "root", "true", "visible", "true", "parentActive", "true", 1, "layout-menu", 3, "item", "expandAll", "reset"], ["href", "#", 1, "layout-sidebar-anchor", 3, "click", "title", "ngClass"], ["icon", "thumbtack", "size", "sm"]],
        template: function LayoutSidebarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("mouseenter", function LayoutSidebarComponent_Template_div_mouseenter_0_listener($event) {
              return ctx.sidebarService.onMouseEnterMenu($event);
            })("mouseleave", function LayoutSidebarComponent_Template_div_mouseleave_0_listener($event) {
              return ctx.sidebarService.onMouseLeaveMenu($event);
            });
            i0.ɵɵelementStart(1, "div", 2)(2, "ui-feature-highlight", 3);
            i0.ɵɵconditionalCreate(3, LayoutSidebarComponent_Conditional_3_Template, 4, 8, "a", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "ui-scrollPanel", null, 0)(6, "div", 5)(7, "div", 6);
            i0.ɵɵelement(8, "ul", 7);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.showPinToggle ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleMap(i0.ɵɵpureFunction0(6, _c1));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("item", ctx.model)("expandAll", ctx.expandAll)("reset", ctx.reset);
          }
        },
        dependencies: [UiFeatureHighlightComponent, NgClass, UiIconComponent, UiScrollPanelComponent, LayoutSidebarMenuComponent, AsyncPipe],
        styles: [".layout-sidebar[_ngcontent-%COMP%]{position:fixed;z-index:1000;height:initial;top:0;bottom:0;background:var(--sidebarBgColor);padding-top:7px}.layout-sidebar[_ngcontent-%COMP%]   .layout-sidebar-anchor-wrapper[_ngcontent-%COMP%]{z-index:1010;position:absolute;right:-13px;top:-5px;border-radius:15px;display:none}.layout-sidebar[_ngcontent-%COMP%]   .layout-sidebar-anchor[_ngcontent-%COMP%]{padding:0 8px;color:var(--sidebarAnchorColor);background:var(--softGreyColor);border:1px solid transparent;border-radius:15px;display:inline-block}.layout-sidebar[_ngcontent-%COMP%]   .layout-sidebar-anchor.pin-menu[_ngcontent-%COMP%]{opacity:1;color:var(--primaryColor)}.layout-sidebar[_ngcontent-%COMP%]   .layout-sidebar-anchor[_ngcontent-%COMP%]:hover{background:var(--primaryColor);color:var(--primaryTextColor);border-color:var(--contentColor)}.layout-sidebar[_ngcontent-%COMP%]   .layout-menu[_ngcontent-%COMP%]{list-style-type:none;margin:0;padding:0}  .has-topbar .layout-sidebar{top:var(--topbarHeight)!important}  .has-topbar .layout-sidebar .layout-sidebar-anchor{top:-10px!important}  .has-bottombar .layout-sidebar{bottom:var(--bottombarHeight)!important}.layout-sidebar[_ngcontent-%COMP%]   ui-feature-highlight.visible[_ngcontent-%COMP%]{top:-9px!important;right:-7px!important}[ui-theme=contrast][_nghost-%COMP%]   .layout-sidebar[_ngcontent-%COMP%], [ui-theme=contrast]   [_nghost-%COMP%]   .layout-sidebar[_ngcontent-%COMP%]{border-right:var(--basicPanelBorder)}@media (min-width: 1280px){.layout-sidebar[_ngcontent-%COMP%]{width:var(--sidebarWidth);top:0;transition-timing-function:cubic-bezier(.86,0,.07,1);transition:left .4s;box-shadow:5px 0 10px 0 var(--sidebarShadowColor);left:calc(-1 * var(--sidebarWidth) + var(--sidebarCollapsedWidth))}.layout-sidebar[_ngcontent-%COMP%]   .layout-sidebar-anchor-wrapper[_ngcontent-%COMP%]{display:block}}@media (max-width: 1279px){.layout-sidebar[_ngcontent-%COMP%]{left:calc(-1 * var(--sidebarWidth));width:var(--sidebarWidth);top:0;transition-timing-function:cubic-bezier(.86,0,.07,1);transition:left .4s;box-shadow:5px 0 10px 0 var(--sidebarShadowColor)}  .layout-mobile-active .layout-sidebar{left:0}}  .layout-slim-active .layout-sidebar{left:0;z-index:9999}  .layout-slim-anchored .layout-sidebar{left:0}  .layout-slim-restore .layout-sidebar{transition:none}  .pin-menu{opacity:.6}"]
      });
    }
  }
  return LayoutSidebarComponent;
})();